<template>
  <v-app-bar
    app
    flat
    fixed
    dark
    height="58"
  >
    <v-app-bar-nav-icon
      class="mr-2"
      @click.stop="$emit('side-icon-clicked')"
    />

    <StLogo
      :link="linkLogo"
    />

    <slot name="center" />

    <v-spacer />

    <StTranslationMenu
      v-if="international"
      :initial-option="initialOption"
      :languages="languages"
      @change="changeLanguage"
    />

    <slot name="right" />

    <v-btn
      v-if="link"
      :href="link"
      target="blank"
      rel="noopener"
      elevation="0"
      class="v-btn__help-center"
      tile
    >
      <v-icon>mdi-comment-question-outline</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import StLogo from '@stilingue/st-logo/StLogo';
import StTranslationMenu from '@stilingue/st-translation-menu/StTranslationMenu';

export default {
  name: 'StHeader',
  components: {
    StLogo,
    StTranslationMenu,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    linkLogo: {
      type: String,
      default: '',
    },
    international: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
      default: () => [],
    },
    initialOption: {
      type: String,
      default: '',
    },
  },
  methods: {
    changeLanguage(language) {
      this.$emit('change', language);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@stilingue/st-styles/colors.scss';

  .v-app-bar {
    padding-left: 0 !important;
    z-index: 9;
    background-color: var(--gray-150);
    border-color: var(--gray-150);

    &__side-icon {
      margin-right: 15px !important;
    }

    .v-btn__help-center {
      background-color: var(--gray-100) !important;
      height: 58px;
      margin-left: 16px;

      &:hover {
        background-color: var(--green-agua-400) !important;
      }
    }
  }

  ::v-deep {
    .v-toolbar__content {
      padding-right: 0;
    }
  }
</style>
